import http from "../../utils/http"

/**
 * 获取分页列表
 */
export function questionPage(params) {
    return http({
        url: "/api/question/page",
        data: params
    })
}
/**
 * 获取详情
 */
export function questionDetail(params) {
    return http({
        url: "/api/question/info",
        data: params
    })
}
/**
 * 获取列表
 */
 export function questionList(params) {
    return http({
        url: "/api/question/list",
        data: params
    })
}

/**
 * 添加问题
 */
 export function addQuestion(params) {
    return http({
        url: "/api/question/add",
        data: params
    })
}

/**
 * 获取我的提问
 */
 export function questionMyPage(params) {
    return http({
        url: "/api/question/myPage",
        data: params
    })
}
